var JhiMissingTranslationHandler = (function () {
    function JhiMissingTranslationHandler(configService) {
        this.configService = configService;
    }
    JhiMissingTranslationHandler.prototype.handle = function (params) {
        var key = params.key;
        return this.configService.getConfig().noi18nMessage + "[" + key + "]";
    };
    return JhiMissingTranslationHandler;
}());
export { JhiMissingTranslationHandler };



//////////////////
// WEBPACK FOOTER
// ./~/ng-jhipster/src/language/jhi-missing-translation.config.js
// module id = 1026
// module chunks = 3